export const validateSchema = (schema) => (values) => {
  try {
    schema.parse(values);
  } catch (error) {
    return error.formErrors.fieldErrors;
  }
};
